import * as arcInMobile from './animation/in/mobile/arcIn';
import * as bounceInMobile from './animation/in/mobile/bounceIn';
import * as cornerInMobile from './animation/in/mobile/cornerIn';
import * as dropClipInMobile from './animation/in/mobile/dropClipIn';
import * as dropInMobile from './animation/in/mobile/dropIn';
import * as expandInMobile from './animation/in/mobile/expandIn';
import * as fadeInMobile from './animation/in/mobile/fadeIn';
import * as flipInMobile from './animation/in/mobile/flipIn';
import * as floatInMobile from './animation/in/mobile/floatIn';
import * as flyInMobile from './animation/in/mobile/flyIn';
import * as foldInMobile from './animation/in/mobile/foldIn';
import * as glideInMobile from './animation/in/mobile/glideIn';
import * as revealMobile from './animation/in/mobile/reveal';
import * as slideInMobile from './animation/in/mobile/slideIn';
import * as spinInMobile from './animation/in/mobile/spinIn';
import * as turnInMobile from './animation/in/mobile/turnIn';

export {
  arcInMobile,
  dropInMobile,
  expandInMobile,
  fadeInMobile,
  flipInMobile,
  floatInMobile,
  flyInMobile,
  foldInMobile,
  revealMobile,
  slideInMobile,
  spinInMobile,
  turnInMobile,
  bounceInMobile,
  glideInMobile,
  dropClipInMobile,
  cornerInMobile,
};
